import axios from "axios";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
export const base_url = process.env.REACT_APP_BASE_URL;
export const api_type = process.env.REACT_APP_API_TYPE;

const toastIds = {
  createSuccess: "create-user-success-toast",
  createError: "create-user-error-toast",
  rolesError: "roles-error-toast",
  permissionRequired: "permission-required-toast",
};

const AddUserManagement = () => {
  const navigate = useNavigate();

  // Input States
  const [firstName, setFirstName] = useState("");
  const [middleName, setMiddleName] = useState("");
  const [lastName, setLastName] = useState("");
  const [role, setRole] = useState("");
  const [email, setEmail] = useState("");
  const [mobile, setMobile] = useState("");
  const [disabledButton, setDisabledtrue] = useState(false);

  const [rolesData, setRolesData] = useState([]);

  // Permissions State
  const [permissions, setPermissions] = useState({
    dashboard: { view: true },
    registration: {
      view: false,
      download: false,
      edit: false,
      approval: false,
    },
    investment: { view: false, download: false },
    bond: { view: false, create: false, edit: false, delete: false },
    cms: { manage: false },
    report: { view: false, upload: false, delete: false },
    user: {
      view: false,
      addRole: false,
      create: false,
      edit: false,
      delete: false,
    },
  });

  // Checkbox Change Handler
  const handleCheckboxChange = (feature, capability) => {
    setPermissions((prev) => ({
      ...prev,
      [feature]: {
        ...prev[feature],
        [capability]: !prev[feature][capability],
      },
    }));
  };

  // Create Button Handler
  const handleCreate = async (event) => {
    event.preventDefault();
    // Collect all the data
    const newUserData = {
      name: firstName,
      roleId: role,
      email,
      mobileNumber: mobile,
      permissions: permissions,
    };

    const hasAnyPermission = Object.values(permissions).some((category) =>
      Object.values(category).some((value) => value === true)
    );

    if (!hasAnyPermission) {
      if (!toast.isActive(toastIds.permissionRequired)) {
        toast.error("At least one permission is required", {
          toastId: toastIds.permissionRequired,
          autoClose: 3000,
        });
      }
      return;
    }

    setDisabledtrue(true);

    const endpoint = `${base_url}/${api_type}/userManagement`;

    try {
      const response = await axios.post(endpoint, newUserData, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`, // Replace 'your-auth-token' with the actual token
        },
      });

      if (!toast.isActive(toastIds.createSuccess)) {
        toast.success(response?.data?.message || "User created successfully", {
          toastId: toastIds.createSuccess,
          autoClose: 3000,
          onClose: () => navigate("/user/creation"),
        });
      }
    } catch (err) {
      if (!toast.isActive(toastIds.createError)) {
        toast.error(err?.response?.data?.message || "Failed to create user", {
          toastId: toastIds.createError,
          autoClose: 3000,
        });
      }
      console.error("Create new user failed:", err);
    }
    setTimeout(() => {
      setDisabledtrue(false);
    }, 5000);
  };

  // Close Button Handler
  const handleClose = () => {
    navigate("/user/creation");
  };

  const getRoles = async () => {
    const endpoint = `${base_url}/${api_type}/roles`;

    try {
      const response = await axios.get(endpoint, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`, // Replace 'your-auth-token' with the actual token
        },
      });
      // toast.success(response?.data?.message);
      if (response?.data?.data?.roles) {
        // Filter unique roles based on 'roleName'
        const uniqueRoles = Array.from(
          new Map(
            response.data.data.roles.map((role) => [role.name, role])
          ).values()
        );
        setRolesData(uniqueRoles); // Set unique roles data
      }
      console.log("response getRoles", response);
    } catch (err) {
      if (!toast.isActive(toastIds.rolesError)) {
        toast.error(err?.response?.data?.message || "Failed to fetch roles", {
          toastId: toastIds.rolesError,
          autoClose: 3000,
        });
      }
      console.error("Failed to fetch roles:", err);
    }
  };

  const handleMobileChange = (e) => {
    let value = e.target.value.replace(/\D/g, ""); // Remove non-digit characters

    if (value.length > 10) return; // Prevent more than 10 digits

    // setPhoneNumber(value);
    setMobile(value);

    if (value.length === 10) {
      e.target.blur(); // Remove focus when 10 digits are entered
    }
  };

  const handleNameChange = (e) => {
    const value = e.target.value;
    // Only allow letters at start, followed by letters, underscores
    if (value === '' || /^[A-Za-z][A-Za-z_]*$/.test(value)) {
      setFirstName(value);
    }
  };

  useEffect(() => {
    getRoles();
  }, []);

  return (
    <div className="w-full mt-[60px] lg:ml-4">
      <div>
        <button
          onClick={() => navigate("/user/creation")}
          className="border-none bg-transparent text-gray-700 text-sm font-bold cursor-pointer py-2.5"
        >
          ← Back
        </button>
      </div>
      <form onSubmit={handleCreate}>
        <div className="bg-white rounded-lg pt-6 pb-6 mt-3 border border-1 border-gray-300">
          <h2 className="text-lg font-medium px-3 sm:px-5">Add New User</h2>
          <div className="border-b border-1 border-gray-300 pb-2"></div>

          {/* First Row */}
          <div className="flex flex-wrap gap-3 sm:gap-6 px-3 sm:px-5 pt-5">
            {/* <div className="flex-1 min-w-[200px]">
            <label className="text-gray-600 text-sm block mb-2">Name</label>
            <input
              type="text"
              value={firstName}
              onChange={(e) => setFirstName(e?.target?.value)}
              placeholder="Enter First Name "
              className="w-full h-10 p-2.5 border-none rounded bg-gray-100"
            />
          </div> */}
            {/* <div className="flex-1 min-w-[200px]">
            <label className="text-gray-600 text-sm block mb-2">
              Middle Name
            </label>
            <input
              type="text"
              placeholder="Enter Middle Name"
              value={middleName}
              onChange={(e) => setMiddleName(e?.target?.value)}
              className="w-full h-10 p-2.5 border-none rounded bg-gray-100"
            />
          </div>
          <div className="flex-1 min-w-[200px]">
            <label className="text-gray-600 text-sm block mb-2">
              Last Name
            </label>
            <input
              type="text"
              value={lastName}
              onChange={(e) => setLastName(e.target.value)}
              placeholder="Enter Last Name"
              className="w-full h-10 p-2.5 border-none rounded bg-gray-100"
            />
          </div> */}
          </div>

          <div className="flex flex-wrap gap-3 sm:gap-6 px-3 sm:px-5 pt-5">
            <div className="flex-1 min-w-[200px]">
              <label className="text-gray-600 text-sm block mb-2">Name</label>
              <input
                type="text"
                value={firstName}
                onChange={handleNameChange}
                placeholder="Enter Name"
                className="w-full h-10 p-2.5 border-none rounded bg-gray-100"
                required
              />
            </div>
            <div className="flex-1 min-w-[200px]">
              <label className="text-gray-600 text-sm block mb-2">Role</label>
              <select
                value={role}
                onChange={(e) => setRole(e.target.value)}
                className="w-full h-10 p-2.5 border-none rounded bg-gray-100"
                required
              >
                <option value="" disabled>
                  Select role
                </option>
                {rolesData?.map((role) => (
                  <option value={role.id}>{role.name}</option>
                ))}
                {/* <option value="User">User</option>
                <option value="Manager">Manager</option> */}
              </select>
            </div>

            <div className="flex-1 min-w-[200px]">
              <label className="text-gray-600 text-sm block mb-2">
                Email ID
              </label>
              <input
                type="email"
                placeholder="Enter Email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="w-full h-10 p-2.5 border-none rounded bg-gray-100"
                required
              />
            </div>

            <div className="flex-1 min-w-[200px]">
              <label className="text-gray-600 text-sm block mb-2">
                Mobile No.
              </label>
              <div className="flex items-center">
                <span className="p-2 bg-gray-200 rounded-lg border-r border-gray-100 mx-2">
                  +91
                </span>
                <input
                  type="text"
                  placeholder="98545XXXXX"
                  value={mobile}
                  onChange={(e) => handleMobileChange(e)}
                  className="w-full h-10 p-2.5 border-none rounded-r bg-gray-100"
                  required
                />
              </div>
            </div>
          </div>
        </div>{" "}
        <div className="bg-white rounded-lg pt-6 pb-6 mt-3 border border-1 border-gray-300">
          <h2 className="text-sm font-medium px-3 sm:px-5 py-2">
            Functionality
          </h2>

          {/* Table */}
          <div className="w-full border border-gray-200 rounded-md overflow-x-auto">
            <div className="grid grid-cols-2 bg-gray-100 font-semibold px-3 sm:px-6 py-3 min-w-[500px]">
              <span>Feature</span>
              <span>Capabilities</span>
            </div>

            {/* Dashboard */}
            <div className="grid grid-cols-2 p-3 sm:p-6 border-b min-w-[500px]">
              <span className="font-semibold ">Dashboard</span>
              <label>
                <input
                  type="checkbox"
                  checked={permissions.dashboard.view}
                  onChange={() => handleCheckboxChange("dashboard", "view")}
                  className="mr-2"
                />
                <span className="text-gray-600 font-medium">View</span>
              </label>
            </div>

            {/* Registration Management */}
            <div className="grid grid-cols-2 p-3 sm:p-6 border-b min-w-[500px]">
              <span className="font-semibold">Registration Management</span>
              <div className="space-y-2 text-gray-600 font-medium">
                {["view", "download", "edit", "approval"].map((item) => (
                  <label key={item} className="block">
                    <input
                      type="checkbox"
                      checked={permissions.registration[item]}
                      onChange={() =>
                        handleCheckboxChange("registration", item)
                      }
                      className="mr-2"
                    />
                    {item.charAt(0).toUpperCase() + item.slice(1)}
                  </label>
                ))}
              </div>
            </div>

            {/* Investment Management */}
            <div className="grid grid-cols-2 p-3 sm:p-6 border-b min-w-[500px]">
              <span className="font-semibold">Investment Management</span>
              <div className="space-y-2 text-gray-600 font-medium">
                {["view", "download"].map((item) => (
                  <label key={item} className="block">
                    <input
                      type="checkbox"
                      checked={permissions.investment[item]}
                      onChange={() => handleCheckboxChange("investment", item)}
                      className="mr-2"
                    />
                    {item.charAt(0).toUpperCase() + item.slice(1)}
                  </label>
                ))}
              </div>
            </div>

            {/* Bond Management */}
            <div className="grid grid-cols-2 p-3 sm:p-6 border-b min-w-[500px]">
              <span className="font-semibold">Bond Management</span>
              <div className="space-y-2 text-gray-600 font-medium">
                {["view", "create", "edit", "delete"].map((item) => (
                  <label key={item} className="block">
                    <input
                      type="checkbox"
                      checked={permissions.bond[item]}
                      onChange={() => handleCheckboxChange("bond", item)}
                      className="mr-2"
                    />
                    {item.charAt(0).toUpperCase() + item.slice(1)}
                  </label>
                ))}
              </div>
            </div>

            {/* CMS */}
            <div className="grid grid-cols-2 p-3 sm:p-6 border-b min-w-[500px]">
              <span className="font-semibold">CMS</span>
              <label>
                <input
                  type="checkbox"
                  checked={permissions.cms.management}
                  onChange={() => handleCheckboxChange("cms", "manage")}
                  className="mr-2  "
                />
                <span className="text-gray-600 font-medium">
                  CMS Management
                </span>
              </label>
            </div>

            {/* Report */}
            <div className="grid grid-cols-2 p-3 sm:p-6 border-b min-w-[500px]">
              <span className="font-semibold">Report</span>
              <div className="space-y-2 text-gray-600 font-medium">
                {["view", "upload", "delete"].map((item) => (
                  <label key={item} className="block">
                    <input
                      type="checkbox"
                      checked={permissions.report[item]}
                      onChange={() => handleCheckboxChange("report", item)}
                      className="mr-2"
                    />
                    {item.charAt(0).toUpperCase() + item.slice(1)}
                  </label>
                ))}
              </div>
            </div>

            {/* User Management */}
            <div className="grid grid-cols-2 p-3 sm:p-6 min-w-[500px]">
              <span className="font-semibold">User Management</span>
              <div className="space-y-2 text-gray-600 font-medium">
                {["view", "addRole", "create", "edit", "delete"].map((item) => (
                  <label key={item} className="block">
                    <input
                      type="checkbox"
                      checked={permissions.user[item]}
                      onChange={() => handleCheckboxChange("user", item)}
                      className="mr-2"
                    />
                    {item
                      .replace(/([A-Z])/g, " $1")
                      .trim()
                      .charAt(0)
                      .toUpperCase() +
                      item
                        .replace(/([A-Z])/g, " $1")
                        .trim()
                        .slice(1)}
                  </label>
                ))}
              </div>
            </div>
          </div>

          {/* Buttons */}
          <div className="flex justify-end space-x-3 mt-4 px-3 sm:px-0 sm:mr-[130px]">
            <div className="flex flex-col sm:flex-row w-full sm:w-auto gap-3 sm:gap-4">
              <button
                type="button"
                onClick={handleClose}
                className="w-full sm:min-w-[150px] text-[#035C98] rounded-[8px] border-2 py-1 px-4 flex justify-center"
              >
                Close
              </button>
              <button
                type="submit"
                disabled={disabledButton}
                className="w-full sm:min-w-[150px] bg-[#035C98] text-white rounded-[8px] border-2 py-1 px-4 flex justify-center"
              >
                Create
              </button>
            </div>
          </div>
        </div>
      </form>
    </div>
  );
};

export default AddUserManagement;
